// 記事レイアウトは application pack（Turbolinks/Rails UJS 起動元）を読み込まないため、
// 記事 pack 側で Turbolinks と Rails UJS を起動する。
// これにより記事ページ初回ロードでも turbolinks:load が発火し、記事間遷移も Turbolinks で動く。
import Rails from '@rails/ujs'
import Turbolinks from 'turbolinks'

if (!window._rails_loaded) {
  Rails.start()
}
Turbolinks.start()
